/*
HubSpot doesnt provide a mechanism of popup appering detection.
So we track animation event that shows the popup.
We should periodically check whether the animation name and element classes changed.
*/

const onLeadinButtonClick = function (event) {
    const popupTitle = this.popupTitle || ""
    try {
        dataLayer.push({
            event: 'popup',
            ec: 'content_click',
            ea: 'click',
            el: popupTitle,
        })
    } catch(e) {
        console.log(e)
    }
    event.currentTarget.removeEventListener('click', onLeadinButtonClick)
}

const onAnimationStart = function(event) {
    if (event.animationName !== "leadinModal-flyin") return
    const target = event.target
    if (!target.classList.contains("leadinModal-content")) return
    const popupTitle = target.ariaLabel
    try {
        dataLayer.push({
            event: 'popup',
            ec: 'content_view',
            ea: 'impression',
            el: popupTitle,
        })
    } catch(e) {
        console.log(e)
    }
    const leadinButtons = target.getElementsByClassName('leadin-button')
    if (leadinButtons.length > 0) {
        leadinButtons[0].addEventListener('click', onLeadinButtonClick.bind({ popupTitle }))
    }
    target.removeEventListener('animationstart', onAnimationStart)
}

window.addEventListener('animationstart', onAnimationStart)


